"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonTypes = exports.PictureButton = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
var ButtonTypes;
(function (ButtonTypes) {
    ButtonTypes["Plus"] = "/images/btn_add_normal.png";
    ButtonTypes["Minus"] = "/images/btn_minus_normal.png";
    ButtonTypes["Delete"] = "/images/btn_delete.png";
    ButtonTypes["Formula"] = "/images/btn_formulas_active.png";
    ButtonTypes["FormulaDisabled"] = "/images/btn_formulas_inactive.png";
    ButtonTypes["Split"] = "/images/btn_split_active.png";
    ButtonTypes["SplitDisabled"] = "/images/btn_split_inactive.png";
    ButtonTypes["Tag"] = "/images/btn_tag.png";
    ButtonTypes["TagNoBackground"] = "/images/icon_tag.svg";
    ButtonTypes["MenuNoBackground"] = "/images/btn_actionmenu.svg";
    ButtonTypes["Help"] = "/images/btn_help.svg";
    ButtonTypes["Unselected"] = "/images/btn_formulas_normal.png";
    ButtonTypes["Selected"] = "/images/btn_formulas_selected.png";
    ButtonTypes["Close"] = "/images/btn_3w_close.png";
    ButtonTypes["ThreeW"] = "/images/btn_3w_normal.png";
    ButtonTypes["Placeholder"] = "";
})(ButtonTypes || (ButtonTypes = {}));
exports.ButtonTypes = ButtonTypes;
function PictureButton(props) {
    const getImageSrc = () => {
        const { buttonType } = props;
        return buttonType;
    };
    const { buttonType, width, height, onClick, placeholder, disabled, className } = props;
    let widthValue = width == null ? 26 : width;
    const heightValue = height == null ? 26 : height;
    if (buttonType == ButtonTypes.ThreeW) {
        widthValue = 50;
    }
    const image = (react_1.default.createElement("img", { src: getImageSrc(), width: widthValue, height: heightValue }));
    return (react_1.default.createElement("button", { type: "button", className: className, onClick: onClick, disabled: placeholder || disabled, style: { visibility: (placeholder ? 'hidden' : 'visible') } }, image));
}
exports.PictureButton = PictureButton;
PictureButton.propTypes = {
    buttonType: prop_types_1.default.string,
    className: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    height: prop_types_1.default.number,
    onClick: prop_types_1.default.func,
    placeholder: prop_types_1.default.bool,
    width: prop_types_1.default.number,
};
PictureButton.defaultProps = {
    onClick: (() => { }),
    placeholder: false,
    disabled: false,
};
